$mol_drag $mol_ghost
	event *
		^
		dragstart? <=> drag_start? <=> start? null
		drag? <=> drag_move? <=> move? null
		dragend? <=> drag_end? <=> end? null
	attr *
		^
		draggable <= draggable true
		mol_drag_status <= status? \ready
	transfer *string
		text/plain <= plain <= title
		text/html <= html \
		text/uri-list <= uris \
	allow_copy true
	allow_link true
	allow_move true
	image <= dom_node
